<template>
  <el-dialog
    title="电汇底单详细信息"
    :visible.sync="isShow"
    destroy-on-close
    width="800px"
    @close="closeDialog"
  >
    <div class="rj-page-card__title">
      电汇底单基本信息
    </div>
    <div class="rj-row">
      <div class="rj-col-2">
        <div class="rj-baseinfo">
          <div class="rj-baseinfo__label">
            电汇编号：
          </div>
          <div class="rj-baseinfo__item">
            {{ formData.telegraphicTransferNum }}
          </div>
        </div>
      </div>
      <div class="rj-col-2">
        <div class="rj-baseinfo">
          <div class="rj-baseinfo__label">
            汇入公司：
          </div>
          <div>{{ formData.accountCompany }}</div>
        </div>
      </div>
      <div class="rj-col-2">
        <div class="rj-baseinfo">
          <div class="rj-baseinfo__label">
            币种：
          </div>
          <div class="rj-baseinfo__item">
            {{ formData.currencyName }}
          </div>
        </div>
      </div>
      <div class="rj-col-2">
        <div class="rj-baseinfo">
          <div class="rj-baseinfo__label">
            客户名称：
          </div>
          <div v-if="formData.newImportCompany" class="rj-baseinfo__item">
            {{ formData.newImportCompany }}
          </div>
          <div v-else class="rj-baseinfo__item">
            {{ formData.importCompany }}
          </div>
        </div>
      </div>
      <div class="rj-col-2">
        <div class="rj-baseinfo">
          <div class="rj-baseinfo__label">
            汇款日期：
          </div>
          <div class="rj-baseinfo__item">
            {{ formData.remittanceDate }}
          </div>
        </div>
      </div>
      <div class="rj-col-2">
        <div class="rj-baseinfo">
          <div class="rj-baseinfo__label">
            汇款金额：
          </div>
          <div class="rj-baseinfo__item">
            {{ formData.remittanceAmount }}
          </div>
        </div>
      </div>
      <div class="rj-col-2">
        <div class="rj-baseinfo">
          <div class="rj-baseinfo__label">
            汇入行：
          </div>
          <div class="rj-baseinfo__item">
            {{ formData.importBank }}
          </div>
        </div>
      </div>
      <div class="rj-col-2">
        <div class="rj-baseinfo">
          <div class="rj-baseinfo__label">
            汇入账户：
          </div>
          <div class="rj-baseinfo__item">
            {{ formData.account }}
          </div>
        </div>
      </div>
      <div class="rj-col-2">
        <div class="rj-baseinfo">
          <div class="rj-baseinfo__label">
            状态：
          </div>
          <div class="rj-baseinfo__item">
            已到账
          </div>
        </div>
      </div>
      <div class="rj-col-2">
        <div class="rj-baseinfo">
          <div class="rj-baseinfo__label">
            备注：
          </div>
          <div class="rj-baseinfo__item">
            {{ formData.summary }}
          </div>
        </div>
      </div>
      <div class="rj-col-2">
        <div class="rj-baseinfo">
          <div class="rj-baseinfo__label">
            可用余额：
          </div>
          <div class="rj-baseinfo__item">
            {{ formData.unusedAmount }}
          </div>
        </div>
      </div>
    </div>

    <div class="rj-page-card__title" style="margin-top: 15px">
      电汇所指订单列表
    </div>

    <div class="money-wrap">
      金额小计：
      <span class="money">{{ totalAssignAmount }}元</span>
    </div>

    <el-table
      :data="tableData"
      border
      style="width: 100%; margin-top: 10px"
      height="180"
    >
      <el-table-column type="index" width="60" label="序号" align="left" />
      <el-table-column prop="contractNum" label="锐捷电子商务合同编号" align="left" />
      <el-table-column prop="erpOrderNum" label="分配订单号" align="left" />
      <el-table-column prop="orderNetSale" label="订单总金额" align="right" header-align="left" />
      <el-table-column prop="assignAmount" label="本次分配金额" align="right" header-align="left" />
      <el-table-column prop="assignDate" label="分配日期" align="left" width="180px" />
      <el-table-column prop="abandon" label="状态" align="left" />
    </el-table>

    <span slot="footer" class="dialog-footer">
      <el-button type="default" size="mini" @click="closeDialog">关 闭</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { selectModelByTelegraphicTransferNum } from '@/API/index.js';

export default {
  data () {
    return {
      isShow: false,
      formData: {},
      tableData: [],
      totalAssignAmount: 0
    };
  },

  methods: {
    openDialog ({ telegraphicTransferNum }) {
      this.isShow = true;
      this.queryData(telegraphicTransferNum);
    },

    closeDialog () {
      this.isShow = false;
      this.formData = {};
      this.tableData = [];
      this.totalAssignAmount = 0;
    },

    queryData (id) {
      selectModelByTelegraphicTransferNum(id).then((res) => {
        let { status, data } = res.data;
        if (status === '200') {
          this.tableData = data.contractAssignGroup;
          this.formData = data.telegraphicTransfer;
          this.totalAssignAmount = data.totalAssignAmount;
        }
      });
    }
  }
};
</script>

<style scoped>
.money-wrap{
  margin-bottom: 10px;
}

.money{
  color: #f60;
}
</style>
